import React from 'react';

import { formatPriceWithCurrency } from 'components/Plan/planUtils';
import {
  PRICE_ANIMATION_CLASS,
  PRICE_ANIMATION_TIME,
  StyledCSSTransition,
  StyledDiagonalLine,
  StyledPerMonth,
  StyledPrice,
  StyledPriceWrapper,
  StyledRestPrice,
  StyledTransitionGroup,
} from 'components/Plan/PlanStyles';

export const PriceComponent = ({
  isDisabled,
  isFree,
  crossedPrice = false,
  currencySymbol,
  price,
  isMonthlyPrice = true,
}) => {
  const formatPrice = formatPriceWithCurrency(currencySymbol);
  let restPrice = '--';
  let integerPrice = '--';

  const isLoading = !isFree && !(price >= 0);

  if (price >= 0) {
    const [integer, fractional] = formatPrice(price);
    integerPrice = integer;
    restPrice = fractional;
  }

  return (
    <StyledPriceWrapper isDisabled={isDisabled} crossedPrice={crossedPrice}>
      <StyledTransitionGroup>
        <StyledCSSTransition
          classNames={PRICE_ANIMATION_CLASS}
          timeout={PRICE_ANIMATION_TIME}
          key={price}
        >
          <StyledPrice isLoading={isLoading}>
            {isFree ? (
              'FREE'
            ) : (
              <>
                {integerPrice}
                {restPrice && <StyledRestPrice>{`.${restPrice}`}</StyledRestPrice>}
                {isMonthlyPrice && <StyledPerMonth>/mo</StyledPerMonth>}
              </>
            )}
            {crossedPrice && <StyledDiagonalLine />}
          </StyledPrice>
        </StyledCSSTransition>
      </StyledTransitionGroup>
    </StyledPriceWrapper>
  );
};
